import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function HeroImage() {
  const swiperRef = useRef(null);

  return (
    <div className="hero-section position-relative">

      {/* LEFT BUTTON */}
      <button
        onClick={() => swiperRef.current?.slidePrev()}
        style={navStyle("left")}
      >
        ‹
      </button>

      {/* RIGHT BUTTON */}
      <button
        onClick={() => swiperRef.current?.slideNext()}
        style={navStyle("right")}
      >
        ›
      </button>

      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        effect="fade"
        autoplay={{ delay: 4000 }}
        pagination={{ clickable: true }}
        loop={true}
        onSwiper={(swiper) => (swiperRef.current = swiper)}  // ✅ important
        className="hero-swiper"
      >
        <SwiperSlide>
          <div
            className="hero-slide"
            style={{
              backgroundImage:
                "url('https://images.pexels.com/photos/842811/pexels-photo-842811.jpeg')",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <div
            className="hero-slide"
            style={{
              backgroundImage:
                "url('https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg')",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <div
            className="hero-slide"
            style={{
              backgroundImage:
                "url('https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg')",
            }}
          />
        </SwiperSlide>
      </Swiper>

      <div className="hero-overlay"></div>
    </div>
  );
}

const navStyle = (position) => ({
  position: "absolute",
  top: "50%",
  [position]: "60px",
  transform: "translateY(-50%)",
  background: "#fff",
  borderRadius: "50%",
  border: "1px solid #ddd",
  width: "48px",
  height: "48px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10,
  cursor: "pointer",
  fontSize: "22px",
});
